import BasicService from "./BasicService";

class ProfitAndLossService extends BasicService {
  constructor() {
    super();
  }

  getProfitAndLoss(fromDate, toDate, branchId, type) {
    let url = `/report/profitandloss`;

    return this.axios
      .get(url, {
        params: {
          fromDate,
          toDate,
          branchId,
          type
        }
      })
      .then(response => response.data);
  }
}

const profitAndLossService = new ProfitAndLossService();
export default profitAndLossService;
